import { OVERLAY_CLICKED, ANNOTATION_CLICKED } from '../collaborations/types';
import { SELECT_COMMENT } from '../../components/Comment/types';
import { COMMENT_BOX_CANCELLED } from '../../components/CommentsBox/types';
import { SET_CURRENT_FILE_ID } from '../../types/current';
import { ADD_COMMENT } from '../../types/comments';

const initialState = [];

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case OVERLAY_CLICKED:
            return [{
                ...action.payload,
                isRemovable: true
            }];
        case ANNOTATION_CLICKED:
        case SELECT_COMMENT:
        case ADD_COMMENT:
        case SET_CURRENT_FILE_ID:
        // case SET_CURRENT_COMMENT_ID:
            return initialState;
        case COMMENT_BOX_CANCELLED:
            if (!action.payload.parentId) {
                return initialState;
            }
            return state;
        default:
            return state;
    }
}
